<div style="display: inline-block; width: fit-content; max-width: 95%;">
    <div style="display: table;">
        <div class="editable_container">
            <div class="editable_field" *ngIf="!record['title']; else hasTitle" [style.cursor]="mdupdsvc.isEditMode ? 'pointer' : 'default'">
                <span class="title">
                    <h2 [ngStyle]="mdupdsvc.getFieldStyle(fieldName)"><i style="color: #cccccc;">No title set</i></h2>
                </span>
            </div>
            <ng-template #hasTitle >
                <div class="title editable_field" [style.cursor]="mdupdsvc.isEditMode ? 'pointer' : 'default'">
                    <h2 [ngStyle]="mdupdsvc.getFieldStyle(fieldName)" (click)="openModal()">
                        {{record.title}}</h2>
                </div>
            </ng-template>
            <button class="edit_button" *ngIf="mdupdsvc.isEditMode" type="button" (click)="openModal('title')" aria-label="edit button">
                <i class="faa faa-pencil icon_enabled" data-toggle="tooltip" title="Edit title"></i>
            </button>
            <button class="undo_button" *ngIf="mdupdsvc.isEditMode" type="button" [disabled]="!updated"
                (click)="undoEditing()" aria-label="undo button">
                <i class="faa faa-undo" [ngClass]="{'icon_enabled': updated, 'icon_disabled': !updated }"
                    data-toggle="tooltip" title="Undo title"></i>
            </button>
        </div>
    </div>
</div>
<div *ngIf="mdupdsvc.isEditMode" style="color: rgb(173, 0, 0); display: inline-block;width: fit-content; max-width:5%;vertical-align: top;text-align: left; padding-left: .5em;">*</div>